/** Prefetch lazy store tab chunks so first bottom-nav tap feels instant. */
const tabPrefetchers: Record<string, () => Promise<unknown>> = {
  '/search': () => import('@/store/pages/SearchPage'),
  '/orders': () => import('@/store/pages/OrdersPage'),
  '/wishlist': () => import('@/store/pages/WishlistPage'),
  '/cart': () => import('@/store/pages/CartPage'),
}

export function prefetchStoreTabRoute(pathname: string): void {
  tabPrefetchers[pathname]?.()
}

export function prefetchStoreBottomNavRoutes(): void {
  Object.values(tabPrefetchers).forEach((load) => {
    void load()
  })
}
